const PARAMETER_ID_PATTERN = /PARM-\d+/gi;

const extractParameterIds = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap(extractParameterIds);
  }

  if (typeof value !== "string") return [];

  const trimmedValue = value.trim();
  if (!trimmedValue) return [];

  try {
    const parsedValue = JSON.parse(trimmedValue);
    if (parsedValue !== trimmedValue) return extractParameterIds(parsedValue);
  } catch {
    // Fall back to extracting parameter IDs from legacy string values.
  }

  return trimmedValue.match(PARAMETER_ID_PATTERN) || [];
};

export const normalizeFormulaVariables = (formulaVariables) =>
  [...new Set(extractParameterIds(formulaVariables))];
